import { render } from "./UploadExcel.vue?vue&type=template&id=5399a9d6&scoped=true"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"

import "./UploadExcel.vue?vue&type=style&index=0&id=5399a9d6&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5399a9d6"]])

export default __exports__